export default __webpack_public_path__ + "50685e3643e1d11d057da3d8f4bec691.png";